import { BadgeCheck } from "lucide-react";
import Nav from "@/components/Nav";
import Footer from "@/components/Footer";
import { FadeUp, SectionLabel } from "@/components/Reveal";
import { useContent } from "@/lib/api";

const ABOUT_IMG = "/images/martina.webp";

export default function About() {
  const content = useContent();
  const certs = content.certifications || [];

  return (
    <div data-testid="about-page">
      <Nav />
      <section className="mx-auto max-w-7xl px-6 pb-28 pt-40 lg:px-12 lg:pt-52">
        <SectionLabel>Chi sono</SectionLabel>
        <FadeUp as="h1" delay={0.1} className="mt-6 max-w-3xl font-display text-5xl leading-[1.05] text-ivory md:text-7xl" data-testid="about-title">
          Piacere,
          <br />
          <span className="italic text-mist">sono Martina.</span>
        </FadeUp>
        <div className="mt-20 grid gap-16 lg:grid-cols-2">
          <FadeUp delay={0.2} className="overflow-hidden">
            <img src={ABOUT_IMG} alt="Martina Serra durante un allenamento" className="aspect-[4/5] w-full object-cover" data-testid="about-image" />
          </FadeUp>
          <div className="flex flex-col justify-center">
            <FadeUp delay={0.25} className="max-w-lg whitespace-pre-line text-sm leading-loose text-ivory/80 md:text-base" data-testid="about-text">
              {content.about_text}
            </FadeUp>
            <div className="mt-16">
              <SectionLabel>Certificazioni</SectionLabel>
              <div className="mt-8 flex flex-col gap-5" data-testid="certifications-list">
                {certs.map((c, i) => (
                  <FadeUp key={i} delay={0.1 * i} className="flex items-center gap-4 border border-line px-6 py-5">
                    <BadgeCheck size={20} className="shrink-0 text-sage" />
                    <p className="text-sm text-ivory/90">{c}</p>
                  </FadeUp>
                ))}
                <FadeUp delay={0.3} className="flex items-center gap-4 border border-dashed border-line px-6 py-5">
                  <span className="h-5 w-5 shrink-0 rounded-full border border-line" />
                  <p className="text-sm italic text-mute">Formazione continua — prossime certificazioni in arrivo</p>
                </FadeUp>
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer content={content} />
    </div>
  );
}
